import { LabelWithValue } from '@/components/common/LabelWithValue';
import type { PcmpProposalDetail } from '../../types/pcmpProposal.types';
import { PcmpProposalSection } from './PcmpProposalSection';
import { PcmpStatusPill } from './PcmpStatusPill';

interface PcmpOfficerCardProps {
  mo: PcmpProposalDetail['mo'];
}

export function PcmpOfficerCard({ mo }: PcmpOfficerCardProps) {
  return (
    <PcmpProposalSection
      title="Marketing Officer"
      actions={mo.isActive ? null : <PcmpStatusPill tone="danger">Inactive</PcmpStatusPill>}
    >
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        <LabelWithValue label="Name">{mo.fullName}</LabelWithValue>
        <LabelWithValue label="Designation">{mo.designationName}</LabelWithValue>
        <LabelWithValue label="HR ID">{mo.hrEmpId}</LabelWithValue>
        <LabelWithValue label="Mobile">{mo.mobile}</LabelWithValue>
        <LabelWithValue label="Thana">{mo.thanaName}</LabelWithValue>
        <LabelWithValue label="District">{mo.districtName}</LabelWithValue>
        <LabelWithValue label="Division">{mo.pcmpDivision}</LabelWithValue>
      </div>
    </PcmpProposalSection>
  );
}
